import {select} from '@ngneat/elf';
import {getInterfaceEntitiesDataSource} from '@store/settings/interface/interface.requests';
import {interfaceStore} from '@store/settings/interface/interface.store';

export class InterfaceQuery {
  store = interfaceStore;

  pagination$ = this.store.pipe(select((state) => state.tablePagination));

  interfaceEntities$ = getInterfaceEntitiesDataSource.data$();
  filters$ = this.store.pipe(select(state => state.filters));

  get totalRows() {
    return this.store.getValue().pagination.total;
  }
}

export const interfaceQuery = new InterfaceQuery();
